import React, { useRef, useContext } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid2';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';

import { useResponsive } from 'src/hooks/use-responsive';
import { useBoundingClientRect } from 'src/hooks/use-bounding-client-rect';

import { HEADER } from 'src/layouts/config-layout';

import { AppContext } from 'src/AppContext';
import Image from 'src/components/image';
import { Link as RouterLink } from 'react-router-dom';
import { brand } from 'src/templates/shared-theme/themePrimitives';


export default function HomeTitle() {
  const theme = useTheme();
  const containerRef = useRef(null);
  const mdUp = useResponsive('up', 'md');
  const container = useBoundingClientRect(containerRef);
  const offsetLeft = container?.left;
  const { user, loading } = useContext(AppContext);

  const bgGradient = ({ imgUrl }) => ({
    backgroundImage: `url(${imgUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: alpha(theme.palette.background.default, 0.9),
  });

  return (
    <Box
      sx={{
        ...bgGradient({
          imgUrl: '/assets/background/index_bg.png',
        }),
        overflow: 'hidden',
        position: 'relative',
        height: { md: `calc(100vh - ${HEADER.H_DESKTOP}px)` },
      }}
    >
      <Container sx={{ height: 1 }}>
        <Grid container columnSpacing={3} alignItems="center" sx={{ height: 1 }}>
          <Grid size={{ xs: 12, md: 5 }}>
            <Stack
              spacing={3}
              justifyContent="center"
              alignItems={{ xs: 'center', md: 'flex-start' }}
              sx={{
                py: 15,
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Typography variant="h1" sx={{ fontSize: '2.4rem' }}>
                <Box component="span" sx={{ color: brand[500], fontSize: '3.8rem', my: 2, display: 'block' }}>
                  {`FitU SG`}
                </Box>
                Choose Your Perfect Trainer Anytime, Anywhere!
              </Typography>

              <Typography sx={{ color: 'text.secondary', fontSize: '1.53rem' }}>
                <Box
                  component={RouterLink}
                  to={user ? "#" : "/signup"}
                  onClick={(event) => {
                    if (user) {
                      event.preventDefault();
                    }
                  }}
                  sx={{
                    width: '100%',
                    fontWeight: 'bold',
                    color: 'white',
                    backgroundColor: brand[400],
                    borderRadius: 1,
                    px: 1.5,
                    py: 1,
                    textDecoration: 'none',
                    pointerEvents: user ? 'none' : 'auto',
                  }}
                >
                  Sign up & Get S$20
                </Box>
              </Typography>

              <Typography sx={{ color: 'text.secondary', fontSize: '1.1rem' }}>
                Find and book certified personal trainers that match your goals, schedule, and style. Switch when you want - no commitments, no hassle.
              </Typography>
            </Stack>
          </Grid>

          <Grid size={{ xs: 12, md: 7 }}>
            <Box ref={containerRef} />
          </Grid>
        </Grid>
      </Container>

      {
        mdUp && (
          <Box
            sx={{
              maxWidth: { md: '40%', xl: '35%' },
              position: 'absolute',
              top: { md: '20%', lg: '15%', xl: '20%' },
              bottom: { md: '20%', lg: '15%', xl: '7%' },
              right: { xs: 0, md: 80, lg: 100, xl: 250 },
              width: { md: `calc(100% - ${offsetLeft}px)` },
            }}
          >
            <Image
              visibleByDefault
              disabledEffect
              alt="home hero"
              src="/assets/images/home/index_app.png"
            />
          </Box>
        )
      }
    </Box >
  );
}
